export default "__VITE_ASSET__C5n3$RDm__"